import React from "react";
import { useDispatch } from "react-redux";
import Modal from "../../../../components/Common/Modal/Modal";
import {
  setPollUserGroup,
  setTenantPollUsers,
} from "../../../../store/actions/actionCreators/socialActionCreator";
import DistributePoll from "./DistributePoll";

const DistributePollModal = ({
  isDistibuteModal,
  setisDistibuteModal,
  pollId,
}) => {
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={isDistibuteModal}
      heading={"Distribute Poll"}
      toggle={() => {
        setisDistibuteModal(false);
        dispatch(setTenantPollUsers(null));
        dispatch(setPollUserGroup(null));
      }}
      width={"100"}
    >
      <DistributePoll
        pollId={pollId}
        setisDistibuteModal={setisDistibuteModal}
      />
    </Modal>
  );
};

export default DistributePollModal;
